import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { SystemSetting } from '../../models/system-setting/system-setting.model';
import { ImageProcessing } from '../../models/system-setting/ImageProcessing.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()

export class SystemSettingService {
  private service = "api/SystemSetting"; //Controller Name
  public systemSettingList: SystemSetting[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddSystemSetting(createSettingModel: SystemSetting) {
    return this.http
      .post(`${this.service}`, createSettingModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response)
      .catch(this.errorHandler);
  }
  UpdateSystemSetting(EditSettingModel: SystemSetting): void {
    this.http
      .put(`${this.service}`, EditSettingModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
      });
  }
  SaveWebsiteLogo(formData: any): void {
    this.http
      .post(`${this.service}/SaveWebsiteLogo`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
      });
  }
  SaveFavIcon(formData: any): void {
    this.http
      .post(`${this.service}/SaveWebsiteFavIcon`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
      });
  }
  GetSystemSettings() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetSystemSettingsById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <SystemSetting>response.json())
      .catch(this.errorHandler)
  }
  GetSystemSettingFirstOrDefault() {
    return this.http.get(`${this.service}/GetSystemSettingFirstOrDefault`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <SystemSetting>response.json())
      .catch(this.errorHandler)
  }
  GetImageServerPath() {
    return this.http.get(`${this.service}/ImageServerPath`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <ImageProcessing>response.json())
      .catch(this.errorHandler);
  }


  DeleteSystemSetting(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/system-settings/system-setting.service.ts